"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _immutable = require("immutable");

var _isEmpty = _interopRequireDefault(require("transmute/isEmpty"));

var _get = _interopRequireDefault(require("transmute/get"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _BaseDialog = _interopRequireDefault(require("customer-data-ui-utilities/dialog/BaseDialog"));

var _PromptablePropInterface = _interopRequireDefault(require("UIComponents/decorators/PromptablePropInterface"));

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var PropertyValueDisplay = _interopRequireWildcard(require("customer-data-property-utils/PropertyValueDisplay"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIAccordionItem = _interopRequireDefault(require("UIComponents/accordion/UIAccordionItem"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/legacy/UIFormControl"));

var _guids = require("reporting-data/lib/guids");

var _propertyTranslator = require("property-translator/propertyTranslator");

var _ConnectReferenceResolvers = _interopRequireDefault(require("reference-resolvers/ConnectReferenceResolvers"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var isPropertyEmpty = function isPropertyEmpty(val) {
  return val == null || ("" + val).trim().length === 0;
};

var LIFECYLCLE_CONTACT_SYNC = 'deals::sync_company_lifecyclestage';

var isTrue = function isTrue(val) {
  return val === true || val === 'true';
};

var DATA_1 = 'hs_analytics_source_data_1';
var DATA_2 = 'hs_analytics_source_data_2';

var isIntegration = function isIntegration(subject) {
  return (0, _ImmutableModel.getProperty)(subject, DATA_1) === _PropertySourceTypes.INTEGRATION;
};

var isImport = function isImport(subject) {
  return (0, _ImmutableModel.getProperty)(subject, DATA_1) === _PropertySourceTypes.IMPORT && !isNaN((0, _ImmutableModel.getProperty)(subject, DATA_2));
};

var StageChangeDialog =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(StageChangeDialog, _PureComponent);

  function StageChangeDialog(props) {
    var _this;

    (0, _classCallCheck2.default)(this, StageChangeDialog);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(StageChangeDialog).call(this, props));
    _this.partial = (0, _ComponentMethods.makePartial)();
    (0, _ComponentMethods.bindAll)((0, _assertThisInitialized2.default)(_this));

    if (!props.subject) {
      return (0, _possibleConstructorReturn2.default)(_this);
    }

    var draft = props.properties.reduce(function (result, property) {
      var propertyName = property.get('property');

      if (result.has(propertyName)) {
        return result;
      }

      var value = props.nextProperties.get(propertyName) || (0, _ImmutableModel.getProperty)(props.subject, propertyName);
      var prevStageProbability = props.prevStage && props.prevStage.get('probability') && +props.prevStage.get('probability');
      var probability = props.nextStage.get('probability') && +props.nextStage.get('probability');

      if (propertyName === 'closedate' && [0, 1].includes(probability) && prevStageProbability !== probability) {
        value = _I18n.default.moment.userTz().valueOf();
      }

      return result.set(propertyName, value);
    }, (0, _immutable.Map)());
    var prefilledProperties = (0, _immutable.List)();
    var emptyProperties = (0, _immutable.List)();
    props.properties.forEach(function (p) {
      var val = draft.get(p.get('property'));

      if (isPropertyEmpty(val)) {
        emptyProperties = emptyProperties.push(p);
      } else {
        prefilledProperties = prefilledProperties.push(p);
      }
    });
    _this.state = {
      changedInSession: (0, _immutable.Set)(),
      draft: draft,
      propertiesByType: {
        completed: prefilledProperties,
        empty: emptyProperties
      }
    };
    return _this;
  }

  (0, _createClass2.default)(StageChangeDialog, [{
    key: "getIsSaveDisabled",
    value: function getIsSaveDisabled() {
      var properties = this.props.properties;
      var draft = this.state.draft;
      var result = properties.some(function (stageProperty) {
        if (!stageProperty.get('required')) return false;
        var value = draft.get(stageProperty.get('property'));
        return isPropertyEmpty(value);
      });
      return result;
    }
  }, {
    key: "shouldUpdateDealCloseDateOnSave",
    value: function shouldUpdateDealCloseDateOnSave(isChangingCloseDate) {
      if (_ObjectTypes.default.DEAL !== this.props.objectType) {
        return false;
      }

      if (isChangingCloseDate) {
        return false;
      }

      var probability = this.props.nextStage.get('probability') && Number(this.props.nextStage.get('probability'));
      var isWonOrLost = [0, 1].includes(probability);
      var prevStageProbability = Number((0, _get.default)('probability', this.props.prevStage));

      if (isWonOrLost && prevStageProbability !== probability) {
        return true;
      }

      return false;
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm() {
      var _this2 = this;

      var currentDraft = this.state.draft.toJS();
      var newPropertiesWithoutUnchaged = Object.keys(currentDraft).reduce(function (acc, key) {
        if (!_this2.state.changedInSession.has(key)) {
          return acc;
        }

        return (0, _extends3.default)({}, acc, (0, _defineProperty2.default)({}, key, currentDraft[key]));
      }, {});
      var newFinalProperties = this.shouldUpdateDealCloseDateOnSave(this.state.changedInSession.has('closedate')) ? (0, _extends3.default)({}, newPropertiesWithoutUnchaged, {
        closedate: _I18n.default.moment.userTz().valueOf()
      }) : newPropertiesWithoutUnchaged;
      return this.props.onConfirm(newFinalProperties);
    }
  }, {
    key: "handleChange",
    value: function handleChange(property, event) {
      var value = event.target != null ? event.target.value : undefined;
      value = PropertyValueDisplay.sanitizeValue(property, value);
      this.setState(function (prevState) {
        return {
          draft: prevState.draft.set(property.name, value),
          changedInSession: prevState.changedInSession.add(property.name)
        };
      });
    }
  }, {
    key: "renderIsSyncedMessage",
    value: function renderIsSyncedMessage() {
      var _this$props = this.props,
          objectType = _this$props.objectType,
          settings = _this$props.settings,
          nextProperties = _this$props.nextProperties;

      if (objectType !== _ObjectTypes.default.DEAL || nextProperties.get('probability') !== 1 || !settings || !isTrue(settings.get(LIFECYLCLE_CONTACT_SYNC))) {
        return null;
      }

      return _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataProperties.dealClosedModal.syncMessage"
      }));
    }
  }, {
    key: "renderPropertyLabel",
    value: function renderPropertyLabel(property) {
      if (property.description) {
        return _react.default.createElement(_UITooltip.default, {
          title: (0, _propertyTranslator.propertyDescriptionTranslator)(property.label)
        }, _react.default.createElement("span", null, (0, _propertyTranslator.propertyLabelTranslator)(property.label)));
      }

      return _react.default.createElement("span", null, (0, _propertyTranslator.propertyLabelTranslator)(property.label));
    }
  }, {
    key: "renderEmptyProperties",
    value: function renderEmptyProperties(emptyProperties) {
      if ((0, _isEmpty.default)(emptyProperties)) {
        return null;
      }

      return _react.default.createElement(_UISection.default, null, emptyProperties.map(this.renderProperty));
    }
  }, {
    key: "renderCompletedProperties",
    value: function renderCompletedProperties(completedProperties, emptyProperties) {
      if ((0, _isEmpty.default)(completedProperties)) {
        return null;
      }

      return _react.default.createElement(_UIAccordionItem.default, {
        className: "p-y-3",
        defaultOpen: (0, _isEmpty.default)(emptyProperties),
        size: "small",
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "customerDataProperties.StageChangeDialog.completedProperties"
        })
      }, completedProperties.map(this.renderProperty));
    }
  }, {
    key: "renderProperty",
    value: function renderProperty(stageProperty) {
      var _this$props2 = this.props,
          nextProperties = _this$props2.nextProperties,
          objectType = _this$props2.objectType,
          resolvers = _this$props2.resolvers,
          subject = _this$props2.subject,
          subjectProperties = _this$props2.subjectProperties,
          getPropertyInputResolver = _this$props2.getPropertyInputResolver,
          PropertyInput = _this$props2.PropertyInput;
      var draft = this.state.draft;
      var property = subjectProperties.get(stageProperty.get('property'));

      if (!property) {
        return null;
      }

      var name = property.name;
      var optionalProps = name === 'dealstage' ? {
        nextPipeline: nextProperties.get('pipeline')
      } : undefined;
      var resolver = getPropertyInputResolver(resolvers, property, objectType, {
        isIntegration: isIntegration(subject),
        isImport: isImport(subject)
      });
      return _react.default.createElement(_UIFormControl.default, {
        key: name,
        label: this.renderPropertyLabel(property),
        required: stageProperty.get('required')
      }, _react.default.createElement(PropertyInput, (0, _extends3.default)({
        baseUrl: "/contacts/" + _hubspot.default.get() + "/contact/email/",
        readOnlySourceData: {
          isKnownGuid: _guids.isKnownGuid,
          getGuidLabel: _guids.getGuidLabel
        },
        objectType: objectType,
        property: property,
        resolver: resolver,
        value: draft.get(name),
        onChange: this.partial(this.handleChange, property),
        subject: subject
      }, optionalProps)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          nextStage = _this$props3.nextStage,
          objectType = _this$props3.objectType,
          onReject = _this$props3.onReject,
          properties = _this$props3.properties,
          subject = _this$props3.subject;
      var _this$state$propertie = this.state.propertiesByType,
          completed = _this$state$propertie.completed,
          empty = _this$state$propertie.empty;
      var i18nKey = objectType === _ObjectTypes.default.TICKET ? 'ticket' : 'deal';
      return _react.default.createElement(_BaseDialog.default, {
        confirmDisabled: this.getIsSaveDisabled(),
        onConfirm: this.handleConfirm,
        onReject: onReject,
        title: _react.default.createElement("h3", null, _react.default.createElement(_FormattedMessage.default, {
          message: "customerDataProperties." + i18nKey + "StageChangeModal.title"
        }))
      }, _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataProperties." + i18nKey + "StageChangeModal.message",
        options: {
          count: properties.size,
          name: (0, _ImmutableModel.toString)(subject),
          stage: nextStage.get('label')
        }
      })), this.renderIsSyncedMessage(), this.renderEmptyProperties(empty), this.renderCompletedProperties(completed, empty));
    }
  }]);
  return StageChangeDialog;
}(_PureComponent2.default);

StageChangeDialog.propTypes = (0, _extends3.default)({
  getPropertyInputResolver: _react.PropTypes.func.isRequired,
  prevStage: _reactImmutableProptypes.default.map,
  nextStage: _reactImmutableProptypes.default.map.isRequired,
  objectType: _react.PropTypes.string.isRequired,
  prevProperties: _reactImmutableProptypes.default.map.isRequired,
  nextProperties: _reactImmutableProptypes.default.map.isRequired,
  properties: _reactImmutableProptypes.default.list.isRequired,
  PropertyInput: _react.PropTypes.elementType.isRequired,
  subject: _reactImmutableProptypes.default.record.isRequired,
  subjectProperties: _reactImmutableProptypes.default.map.isRequired,
  settings: _reactImmutableProptypes.default.map.isRequired
}, _PromptablePropInterface.default);

var _default = (0, _ConnectReferenceResolvers.default)(function (resolvers) {
  return {
    resolvers: resolvers
  };
}, StageChangeDialog);

exports.default = _default;
module.exports = exports.default;